import { render } from "./ModalTableResetSpending.vue?vue&type=template&id=5e25ebd6&scoped=true"
import script from "./ModalTableResetSpending.vue?vue&type=script&lang=js"
export * from "./ModalTableResetSpending.vue?vue&type=script&lang=js"

import "./ModalTableResetSpending.vue?vue&type=style&index=0&id=5e25ebd6&scoped=true&lang=css"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e25ebd6"]])

export default __exports__